import promotionImage from '../../../assets/promotion.png';
import TierLevel from './TierLevel';
import PhenomBalance from './PhenomBalance';
import WalletBalance from './WalletBalance';
import { FiCopy } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import { ReducerState } from '../../../services/common/lib/reducerState';
import LogoutButton from './LogoutButton';
import { useToast } from '@/components/toast/useToast';

const UserWalletInfo = () => {
  const { toast } = useToast();

  const PROMOTION_URL = 'https://www.phenompoker.com/promotions';

  const referrerCode = useSelector((state: ReducerState) => state.auth.referrerCode);
  const handleCopyToClipboard = () => {
    toast({ description: `Referral link copied!`, variant: 'success' });
    const url = `${window.location.origin}/register?r=${referrerCode}`;

    return navigator.clipboard.writeText(url);
  };

  const handleClickOnPromotion = () => {
    window.open(PROMOTION_URL, '_blank');
  };

  return (
    <section className="flex h-full flex-col items-center justify-between gap-4 px-7">
      <div className="flex w-full flex-col items-center justify-center gap-4">
        <WalletBalance />

        <TierLevel />

        <PhenomBalance />
      </div>

      <div className="my-8 flex w-full flex-col gap-2 align-middle">
        <img src={promotionImage} alt="promotion" className="w-full cursor-pointer" onClick={handleClickOnPromotion} />

        <div
          className="mt-4 flex select-none items-center justify-center gap-2 align-middle text-ph-primary-violet hover:cursor-pointer hover:text-ph-secondary-portage"
          onClick={handleCopyToClipboard}
        >
          <FiCopy className="text-sm" />
          <p className="font-manrope text-sm font-bold">Copy my referral link</p>
        </div>
      </div>
      <div className="mb-8 flex flex-col items-center justify-center gap-4">
        <LogoutButton />
      </div>
    </section>
  );
};

export default UserWalletInfo;
